/**
 * Application Table Constants
 * Centralized configuration and constants for ApplicationTable component
 */

// Pagination
export const ITEMS_PER_PAGE = 15;

// Status options for filtering
export const STATUS_OPTIONS = {
  ALL: "All",
  APPLIED: "applied",
  INTERVIEW: "interview",
  OFFER: "offer",
  REJECTED: "rejected",
  ARCHIVED: "archived",
};

// Status badge color mapping
export const STATUS_BADGE_COLORS = {
  applied: "blue",
  interview: "purple",
  offer: "green",
  rejected: "red",
  archived: "gray",
};

// JavaScript field names to database field names mapping
export const DB_FIELD_MAP = {
  jobLocationCity: "job_location_city",
  status: "status",
  notes: "notes",
};

// Status card configuration for dashboard
export const STATUS_CARDS = [
  { label: "Applied", key: "All" },
  { label: "Interview", key: "interview" },
  { label: "Offer", key: "offer" },
  { label: "Rejected", key: "rejected" },
  { label: "Archived", key: "archived" },
];

// Table column sort fields
export const SORT_FIELDS = {
  APPLICATION_DATE: "applicationDate",
  COMPANY_NAME: "companyName",
  ROLE_TITLE: "roleTitle",
  STATUS: "status",
  LOCATION: "jobLocationCity",
};
